import type { Dictionary } from './ru';

/** Казахский словарь. Набор ключей обязан совпадать с ru — это проверяет тип Dictionary. */
export const kk: Dictionary = {
  'app.name': 'WaterFlow',
  'app.subtitle': 'Сумен жабдықтауды басқару',

  'nav.group.subscribers': 'Абоненттер',
  'nav.group.metering': 'Су есебі',
  'nav.group.finance': 'Қаржы',
  'nav.group.network': 'Желілер және диспетчерлік',
  'nav.group.analytics': 'Талдау',
  'nav.group.admin': 'Әкімшілендіру',
  'nav.subscribers': 'Жеке шоттар',
  'nav.requests': 'Өтініштер',
  'nav.meters': 'Есептеу аспаптары',
  'nav.readings': 'Көрсеткіштер',
  'nav.anomalies': 'Ауытқулар журналы',
  'nav.billing': 'Есептеулер',
  'nav.invoices': 'Түбіртектер',
  'nav.payments': 'Төлемдер',
  'nav.cashShift': 'Касса ауысымы',
  'nav.debt': 'Берешек',
  'nav.infrastructure': 'Желілер картасы',
  'nav.dispatch': 'Диспетчерлік',
  'nav.reports': 'Есептер',
  'nav.dashboard': 'Бақылау тақтасы',
  'nav.admin': 'Жүйе баптаулары',
  'nav.users': 'Пайдаланушылар',
  'nav.roles': 'Рөлдер мен құқықтар',
  'nav.dictionaries': 'Анықтамалықтар',
  'nav.tariffs': 'Тарифтер',
  'nav.audit': 'Аудит',

  'action.create': 'Жасау',
  'action.save': 'Сақтау',
  'action.cancel': 'Бас тарту',
  'action.close': 'Жабу',
  'action.delete': 'Жою',
  'action.edit': 'Өзгерту',
  'action.search': 'Іздеу',
  'action.filter': 'Сүзгілер',
  'action.reset': 'Тазалау',
  'action.apply': 'Қолдану',
  'action.export': 'Экспорт',
  'action.exportCsv': 'CSV жүктеу',
  'action.exportExcel': 'Excel жүктеу',
  'action.print': 'Басып шығару',
  'action.refresh': 'Жаңарту',
  'action.back': 'Артқа',
  'action.next': 'Әрі қарай',
  'action.confirm': 'Растау',
  'action.select': 'Таңдау',
  'action.selectAll': 'Барлығын таңдау',
  'action.more': 'Тағы',
  'action.open': 'Ашу',
  'action.copy': 'Көшіру',
  'action.download': 'Жүктеп алу',
  'action.upload': 'Жүктеу',
  'action.retry': 'Қайталау',

  'common.loading': 'Жүктелуде…',
  'common.noData': 'Дерек жоқ',
  'common.notFound': 'Ештеңе табылмады',
  'common.error': 'Қате',
  'common.total': 'Барлығы',
  'common.selected': 'Таңдалды',
  'common.of': 'ішінен',
  'common.page': 'Бет',
  'common.rowsPerPage': 'Беттегі жолдар',
  'common.all': 'Барлығы',
  'common.yes': 'Иә',
  'common.no': 'Жоқ',
  'common.from': 'бастап',
  'common.to': 'дейін',
  'common.period': 'Кезең',
  'common.date': 'Күні',
  'common.amount': 'Сома',
  'common.status': 'Мәртебе',
  'common.address': 'Мекенжай',
  'common.phone': 'Телефон',
  'common.email': 'Эл. пошта',
  'common.comment': 'Түсініктеме',
  'common.author': 'Авторы',
  'common.createdAt': 'Жасалды',
  'common.updatedAt': 'Өзгертілді',
  'common.actions': 'Әрекеттер',
  'common.required': 'Міндетті өріс',
  'common.optional': 'міндетті емес',
  'common.balance': 'Сальдо',
  'common.debt': 'Берешек',
  'common.accountNumber': 'Жеке шот',
  'common.subscriber': 'Абонент',
  'common.district': 'Учаске',
  'common.category': 'Санат',
  'common.service': 'Қызмет',
  'common.volume': 'Көлем',
  'common.tariff': 'Тариф',

  'topbar.search': 'Абонент іздеу: аты-жөні, жеке шот, мекенжай, телефон',
  'topbar.searchHint': 'іздеу үшін',
  'topbar.period': 'Есептік кезең',
  'topbar.notifications': 'Хабарламалар',
  'topbar.noNotifications': 'Жаңа хабарлама жоқ',
  'topbar.markAllRead': 'Барлығын оқылды деп белгілеу',
  'topbar.profile': 'Профиль',
  'topbar.settings': 'Баптаулар',
  'topbar.logout': 'Шығу',
  'topbar.theme': 'Тақырып',
  'topbar.theme.light': 'Ашық',
  'topbar.theme.dark': 'Қараңғы',
  'topbar.theme.system': 'Жүйелік',
  'topbar.language': 'Тіл',
  'topbar.collapse': 'Мәзірді жию',
  'topbar.expand': 'Мәзірді жаю',

  'status.subscriber.draft': 'Жоба',
  'status.subscriber.active': 'Қолданыстағы',
  'status.subscriber.suspended': 'Тоқтатылған',
  'status.subscriber.closed': 'Жабылған',
  'status.subscriber.archived': 'Мұрағатта',

  'status.meter.in_stock': 'Қоймада',
  'status.meter.installed': 'Орнатылған',
  'status.meter.removed': 'Демонтаждалған',
  'status.meter.in_repair': 'Жөндеуде',
  'status.meter.faulty': 'Ақаулы',
  'status.meter.written_off': 'Есептен шығарылған',

  'status.invoice.draft': 'Жоба',
  'status.invoice.issued': 'Есептелген',
  'status.invoice.delivered': 'Жеткізілген',
  'status.invoice.partially_paid': 'Ішінара төленген',
  'status.invoice.paid': 'Төленген',
  'status.invoice.overdue': 'Мерзімі өткен',
  'status.invoice.cancelled': 'Жойылған',

  'status.run.created': 'Жасалды',
  'status.run.preparing': 'Дайындық',
  'status.run.queued': 'Кезекте',
  'status.run.processing': 'Орындалуда',
  'status.run.aggregating': 'Жиынтықтау',
  'status.run.completed': 'Аяқталды',
  'status.run.failed': 'Қате',
  'status.run.cancelled': 'Тоқтатылды',

  'status.payment.pending': 'Бөлінбеген',
  'status.payment.partial': 'Ішінара бөлінген',
  'status.payment.allocated': 'Бөлінген',
  'status.payment.cancelled': 'Тоқтатылған',
  'status.payment.returned': 'Қайтарылған',

  'status.request.new': 'Жаңа',
  'status.request.in_progress': 'Жұмыста',
  'status.request.waiting': 'Күтуде',
  'status.request.resolved': 'Орындалды',
  'status.request.rejected': 'Қабылданбады',
  'status.request.cancelled': 'Тоқтатылды',

  'auth.title': 'Жүйеге кіру',
  'auth.subtitle': 'Сумен жабдықтауды басқарудың корпоративтік платформасы',
  'auth.email': 'Электрондық пошта',
  'auth.password': 'Құпиясөз',
  'auth.remember': 'Мені есте сақтау',
  'auth.forgot': 'Құпиясөзді ұмыттыңыз ба?',
  'auth.signIn': 'Кіру',
  'auth.resetTitle': 'Құпиясөзді қалпына келтіру',
  'auth.resetHint': 'Поштаңызды көрсетіңіз — жаңа құпиясөз сілтемесін жібереміз',
  'auth.resetSubmit': 'Сілтеме жіберу',
  'auth.backToLogin': 'Кіру бетіне оралу',

  'error.forbidden.title': 'Құқық жеткіліксіз',
  'error.forbidden.text': 'Қажет болса, жүйе әкімшісіне хабарласыңыз.',
  'error.notFound.title': 'Бет табылмады',
  'error.notFound.text': 'Мекенжайды тексеріңіз немесе басты бетке оралыңыз.',
  'error.generic.title': 'Бірдеңе дұрыс болмады',
  'error.generic.text': 'Әрекетті қайталаңыз. Қате қайталанса — қолдау қызметіне хабарлаңыз.',
};
